export enum EExpositionClimatique {
    Interieur = 1,
    Exterieur = 2,
    SemiOuvert = 3
}